<template>
  <div class="prism-player" id="player-con"></div>
</template>
<script>
export default {
  name: "aliplayer",
  props: {
    vid: {
      type: String,
    },
    playauth: {
      type: String,
    },
  },
  data() {
    return {
      player: null,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.player = new Aliplayer({
        id: "player-con",
        vid: this.vid,
        playauth: this.playauth,
        qualitySort: "asc",
        format: "mp4",
        mediaType: "video",
        aspectRatio: "16:9",
        width: "100%",
        height: "400px",
        autoplay: false,
        isLive: false,
        rePlay: false,
        playsinline: true,
        preload: true,
        controlBarVisibility: "hover",
        useH5Prism: true,
      });
    },
    play() {
      // console.log("play callback");
    },
  },
};
</script>
<style>
.prism-player /deep/video {
  position: absolute;
  left: 50%;
  top: 50%;
  object-fit: fill !important;
}
</style>



// WEBPACK FOOTER //
// src/components/aliplayer.vue